import Router from './router'
import Msal from './msal'
import Hotjar from './hotjar'
import Head from './head'

export default [Router, Msal, Hotjar, Head]
